import React from 'react';
import { SettingCard, SettingCardProps } from '../SettingCard/SettingCard';
import './NavigationSetting.css';

export interface NavigationSettingProps extends Omit<
	SettingCardProps,
	'content' | 'className' | 'showContentSeparator' | 'disabled'
> {
	onClick: () => void;
}

export const NavigationSetting: React.FC<NavigationSettingProps> = ({
	title,
	description,
	onClick,
	settingId,
	learnMoreUrl,
	learnMoreText,
}) => {
	return (
		<div className="navigation-setting" onClick={onClick}>
			<SettingCard
				title={title}
				description={description}
				settingId={settingId}
				learnMoreUrl={learnMoreUrl}
				learnMoreText={learnMoreText}
				content={
					<div className="navigation-arrow">
						<svg
							width="20"
							height="20"
							viewBox="0 0 20 20"
							fill="none"
							xmlns="http://www.w3.org/2000/svg"
						>
							<g clipPath="url(#clip0_8448_5765)">
								<path
									fillRule="evenodd"
									clipRule="evenodd"
									d="M12.8653 10.1504C12.9461 10.0674 12.9461 9.93264 12.8653 9.84955L4.34875 1.08964C4.10641 0.840372 4.10641 0.436224 4.34875 0.186953C4.5911 -0.0623177 4.98402 -0.0623177 5.22636 0.186953L13.7429 8.94686C14.3084 9.52849 14.3084 10.4715 13.7429 11.0531L5.22636 19.813C4.98402 20.0623 4.5911 20.0623 4.34875 19.813C4.10641 19.5638 4.10641 19.1596 4.34875 18.9104L12.8653 10.1504Z"
									fill="#171717"
								/>
							</g>
							<defs>
								<clipPath id="clip0_8448_5765">
									<rect width="20" height="20" fill="white" />
								</clipPath>
							</defs>
						</svg>
					</div>
				}
			/>
		</div>
	);
};
